







































































































import { Component, Vue } from "vue-property-decorator";
import paxReport from "@/store/entities/flight/paxReport";
import moment from "moment";
import ajax from "@/lib/ajax";
@Component
export default class PaxReport extends Vue {
  breadcrumbsItems: any[] = [];
  pax: paxReport = new paxReport();
  startDate: string = null;
  startDateMenu: boolean = false;
  endDate: string = null;
  endDateMenu: boolean = false;
  paxCount = null;

  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";

    
  }

  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  async searchFlights() {
    const payload: paxReport = {
      starts:  this.startDate,
      ends: this.endDate,
      count: null,
    };
    const response = await ajax.get(
      "/api/services/app/flight/GetFlightOrderCount",
      { params: { ...payload } }
    );
    this.paxCount = response.data.result;
  }

  created() {
    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "Pax Report", disabled: true },
    ];
  }
}
